import { FaHeadset, FaCommentDots } from "react-icons/fa";
import DropdownItemBase from "./DropdownItemBase";
import { useTranslation } from "react-i18next";

const DropdownItemChamado = ({ notif, onClick }) => {
    const { t } = useTranslation(['layout']);
    const info = notif.chamado_info;
    if (!info) return null;

    const isResposta = info.mensagem_resposta;
    const dataRaw = info.data_abertura; 
    
    let dataFormatada = "";
    if (dataRaw) {
        if (dataRaw.includes('/')) {
            dataFormatada = dataRaw;
        } else {
            try {
                const data = new Date(dataRaw);
                dataFormatada = data.toLocaleString("pt-BR", {
                    day: "2-digit", month: "2-digit", year: "numeric",
                    hour: "2-digit", minute: "2-digit",
                });
            } catch (e) { dataFormatada = dataRaw; }
        }
    }

    return (
        <DropdownItemBase
            icon={isResposta ? <FaCommentDots /> : <FaHeadset />}
            text={isResposta ? "text-info" : "text-success"}
            titulo={isResposta ? t('layout:notificationItems.ticket.update', { numero: info.numero }) : t('layout:notificationItems.ticket.new', { numero: info.numero })}
            descricao={isResposta ? t('layout:notificationItems.ticket.checkUpdates') : `${t('layout:notificationItems.label.by')}: ${info.solicitante_nome}`}
            dataFormatada={dataFormatada}
            onClick={() => onClick(notif)}
        />
    );
};

export default DropdownItemChamado;
